import React from 'react';
import PropTypes from 'prop-types';

/**
 * Full-page loader shown until the site has loaded. Brand-aligned purple spinner.
 */
export default class PageLoader extends React.PureComponent {
  render() {
    const { isVisible, isHiding } = this.props;

    if (!isVisible && !isHiding) {
      return null;
    }

    return (
      <div
        className={`page-loader${isHiding ? ' page-loader--hiding' : ''}`}
        aria-hidden="true"
      >
        <div className="page-loader__backdrop" />
        <div className="page-loader__content">
          <div className="page-loader__spinner" aria-label="Loading" />
        </div>
      </div>
    );
  }
}

PageLoader.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isHiding: PropTypes.bool,
};

PageLoader.defaultProps = {
  isHiding: false,
};
